import React from 'react';
import ReactDOM from 'react-dom/client'; // Note the difference in import
import './index.css';
import App from './App.js';

const root = ReactDOM.createRoot(document.getElementById('root')); // Create root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
